// src/components/tools/room-ideas/constants.js

// -----------------------------
// Room Types
// -----------------------------
export const ROOM_TYPES = [
  { value: "bathroom", label: "Bathroom" },
  { value: "bedroom", label: "Bedroom" },
  { value: "kitchen", label: "Kitchen" },
  { value: "living_room", label: "Living Room" },
  { value: "family_room", label: "Family Room" },
  { value: "closet", label: "Closet" },
  { value: "pantry", label: "Pantry" },
  { value: "laundry_room", label: "Laundry Room" },
  { value: "garage", label: "Garage" }
];

// -----------------------------
// Style Options
// (can mirror your existing form)
// -----------------------------
export const STYLE_OPTIONS = [
  { value: "modern", label: "Modern" },
  { value: "contemporary", label: "Contemporary" },
  { value: "farmhouse", label: "Farmhouse" },
  { value: "traditional", label: "Traditional" },
  { value: "luxury", label: "Luxury" },
  { value: "industrial", label: "Industrial" },
  { value: "minimalist", label: "Minimalist" },
  { value: "coastal", label: "Coastal" },
  { value: "rustic", label: "Rustic" }
];

// -----------------------------
// Budget Ranges
// -----------------------------
export const BUDGET_RANGES = [
  {
    value: "low",
    label: "Budget-Friendly",
    description: "Cosmetic upgrades and affordable finishes"
  },
  {
    value: "medium",
    label: "Mid-Range",
    description: "Quality materials with noticeable upgrades"
  },
  {
    value: "high",
    label: "High-End",
    description: "Premium finishes and designer-level upgrades"
  }
];

// -----------------------------
// Default Form Values
// -----------------------------
export const DEFAULT_FORM_VALUES = {
  roomType: "",
  style: "",
  budget: "",
  primaryColor: "",
  secondaryColor: "",
  referenceImage: null
};

// -----------------------------
// Image Generation Settings
// (used later by API / UI expectations)
// -----------------------------
export const IMAGE_GENERATION_CONFIG = {
  imageCount: 4,
  aspectRatio: "1:1", // collage-friendly
  quality: "high"
};
